<div class="dashboard-table mt-8">
  <ag-grid-angular
    style="width: 100%"
    class="ag-theme-alpine lty-table"
    [rowData]="logsList"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [rowClassRules]="rowClassRules"
    [domLayout]="'autoHeight'"
    [pagination]="false"
    [animateRows]="false"
    [suppressRowHoverHighlight]="true"
    [suppressRowTransform]="true"
    [suppressRowClickSelection]="true"
    (cellClicked)="onCellClicked($event)"
  />
</div>
